<!--suppress ALL -->
<script lang="ts">
  import {jenisKelamins} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";
  import AppConfig from "../../../AppConfig";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class JenisKelaminSelect extends Vue {

    @Prop({default: jenisKelamins[0].value, type: String})
    private kelamin: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public disabled: boolean;

    @Prop({
      default: () => AppConfig.getVm().$t('label.jenis_kelamin').toString(),
      type: String
    })
    public label: string;

    @Prop({type: String, default: ""})
    public message: string;

    @Prop({type: String, default: ""})
    public type: string;

    public onSelectJenisKelamin(param: string) {
      this.$emit('update:kelamin', param || jenisKelamins[0].value);
      this.$emit('kelamin-selected', param);
    }

    public render(createElement: Function) {
      const {$t, kelamin, isFullwidth, label, message, type} = this;

      const mainAttr: any = {
        attrs: {disabled: this.disabled},
        props: {
          value: kelamin, isFullwidth,
          placeholder: `${$t('label.choose')} ${label}`
        },
        on: {change: this.onSelectJenisKelamin}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(jenisKelamins).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label, message, type}}, [main]);
    }
  }
</script>
